import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  DirectorSpecificEmployeeView
} from "../../Repository/Api";
import { errorMsg } from "../Toastify";

const DirectorEmployeeSpecificView = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [specificEmployee, setSpecificEmployee] = useState({});

  useEffect(() => {
    getSpecificEmployee();
  },[]);
  const getSpecificEmployee = async () => {
    const response = await DirectorSpecificEmployeeView(id, token);
    if (response && response.statusCode === 200) {
      setSpecificEmployee(response.data);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Employee List
                </h6>
                <div className="row">
                  <div className="col-lg-3">
                    <label className="labeltext">Name of the Applicant</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={specificEmployee?.first_name}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Last Name</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={specificEmployee?.last_name}
                      disabled
                    />
                  </div>
                  {specificEmployee?.user_type_value === "employee" ? (
                    <div className="col-lg-3">
                      <label className="labeltext">Designation</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.designation}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  {specificEmployee?.user_type_value === "admin" ? (
                    ""
                  ) : (
                    <div className="col-lg-3">
                      <label className="labeltext">Department</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificEmployee?.department}
                        disabled
                      />
                    </div>
                  )}
                  {specificEmployee?.user_type_value === "employee" ? (
                    <div className="col-lg-3">
                      <label className="labeltext"> Employee ID </label>
                      <input
                        type="text"
                        className="fieldinput"
                        defaultValue={specificEmployee?.employee_id}
                        disabled
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-lg-3">
                    <label className="labeltext">Email ID</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={specificEmployee?.email_id}
                      disabled
                    />
                  </div>
                  <div className="col-lg-3">
                    <label className="labeltext">Phone Number</label>
                    <input
                      type="text"
                      className="fieldinput"
                      value={specificEmployee?.phone_number}
                      disabled
                    />
                  </div>
                  {specificEmployee?.user_type_value === "employee" ? (
                    <>
                      <div className="col-lg-3">
                        <label className="labeltext"> Gender</label>
                        <input
                          type="text"
                          className="fieldinput"
                          defaultValue={specificEmployee?.gender}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Date Of Birth</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(specificEmployee?.dob).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Date Of Join</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={moment(specificEmployee?.doj).format(
                            "DD-MM-yyyy"
                          )}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Staff Type</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.officer_type}
                          disabled
                        />
                      </div>
                      <div className="col-lg-3">
                        <label className="labeltext">Marital Status</label>
                        <input
                          type="text"
                          className="fieldinput"
                          value={specificEmployee?.marital_status}
                          disabled
                        />
                      </div>
                    </>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorEmployeeSpecificView;
